<template>
    <div class="template-base">
        <MessageBox :caption="messageBox_caption" :message="messageBox_Message" :tag="messageBox_Tag" v-if="messageBox_show" @on-no="onMessageBoxNo" @on-yes="onMessageBoxYes_Delete" />
        <Header Title="Discounts" class="div-header" :isProcessing="fetchData || isProcessing" :errorMessage="errorMessage" :processingMessage="processingMessage"/>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" />
            <Button class="x-smaller-button" :buttonModel="btnAdd" @on-clicked="Add" />
            <div style="display:flex;align-items:flex-start; flex-direction:column;margin: 0px 5px">
                <div>Filter Name:</div>
                <input type="text" v-model="searchNameText" :onKeyUp="updateFilter" />
            </div>            
        </div>
        <div class="select-button-container div-body" style="overflow-y: auto;">
            <div class="select-button-container">
                <DiscountItem v-for="discount in discounts" :key="discount.discountId" :discount="discount" @on-error="onError" @on-delete="onDelete" @on-dirty="onDirty" @on-serverprocessing="onServerProcessing" />
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import Header from "../../components/Shared/Header";
import DiscountItem from "../../components/Administrator/DiscountItem";
import Button from "../../components/Shared/Button";
import MessageBox from "../../components/Shared/MessageBox";
import ButtonModel from "../../models/ButtonModel";
import { ref } from "vue";
import globalStatus from "../../composables/globalStatus";
import apiDiscount from '../../api/apiDiscount';

export default {
    components: { Header, DiscountItem, Button, MessageBox },
    setup() {
        const { fetchData, isProcessing, errorMessage, resetStatus, processingMessage, setMessage } = globalStatus();
        
        const btnExit = ButtonModel.CreateRoute("Exit", "Home");
        const btnAdd = ButtonModel.CreateClick("New Discount");

        var discounts_base = [];
        const discounts = ref([]);
        const searchNameText = ref("");

        const searchKeyType = ref(-1);

        const messageBox_caption = ref("");
        const messageBox_Message = ref("");
        const messageBox_Tag = ref(null);
        const messageBox_show = ref(false);

        var dirtyCount = 0;

        onBeforeRouteLeave((/*to, from*/) => {
            // check if any components are dirty            
            if (dirtyCount > 0) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }
        });

        window.onbeforeunload = () => {
            if (dirtyCount > 0) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }
        };

        const onDirty = (isDirty) => {
            if (isDirty) dirtyCount++;
            else dirtyCount--;
        };

        const updateFilter = () => {
            discounts.value.forEach((item) => {
                var isVisible = item.discountName.includes(searchNameText.value);
                if (searchKeyType.value != -1) isVisible = isVisible && item.hotKeyType == searchKeyType.value;

                item.isVisible = isVisible;
            });
        };

        const onError = (err) => {
            console.error(err);
            errorMessage.value = err;
        };

        const getData = async () => {
            try {
                resetStatus("Loading...");
                discounts_base = await apiDiscount.getAll();
                discounts.value = discounts_base;                
            } catch (err) {
                console.error(err);
                errorMessage.value = "Error loading data";
            }
            fetchData.value = false;
        };
        getData();

        const Add = async () => {
            try {
                resetStatus("Creating Discount...");
                var newDiscount = await apiDiscount.create();
                discounts.value.unshift(newDiscount);
            } catch (err) {
                console.error(err);
                errorMessage.value = "Error creating new discount";
            }
            fetchData.value = false;
        };

        const onDelete = async (item) => {
            messageBox_caption.value = "Delete Discount";
            messageBox_Message.value = "Are you sure you want to delete discount " + item.discountName + "?";
            messageBox_Tag.value = item;
            messageBox_show.value = true;            
        };

        const onMessageBoxYes_Delete = async (item) => {
            try {
                resetStatus("Deleting Discount...");
                await apiDiscount.delete(item.discountId);
                var index = discounts.value.indexOf(item);
                if (index > -1) discounts.value.splice(index, 1);
            } catch (err) {
                console.error(err);
                errorMessage.value = "Error deleting discount";
            }
            fetchData.value = false;

            onMessageBoxNo();
        };

        const onServerProcessing = (process) => {
            isProcessing.value = process
            if (process) setMessage("Saving...");
        };

        const onMessageBoxNo = () => {
            messageBox_show.value = false;
            messageBox_caption.value = "";
            messageBox_Message.value = "";
            messageBox_Tag.value = null;
        };

        return {
            btnExit,
            btnAdd,
            discounts,            
            fetchData,
            errorMessage,
            onError,
            searchNameText,
            updateFilter,
            searchKeyType,            
            Add,
            onDelete,
            messageBox_caption,
            messageBox_Message,
            messageBox_Tag,
            messageBox_show,
            onMessageBoxNo,
            onMessageBoxYes_Delete,
            onDirty, 
            processingMessage,
            onServerProcessing,
            isProcessing
        };
    }
};
</script>

<style></style>
